module.exports = __webpack_public_path__ + "img/45.a5ad2a26.png";